var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "club-points-calendar" }, [
    _c("div", { staticClass: "club-points-calendar__points-at-date" }, [
      _c("div", {
        staticClass: "club-points-calendar__at-date",
        domProps: { innerHTML: _vm._s(_vm.pointsAtTitle) }
      }),
      _c("div", { staticClass: "club-points-calendar__points" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm._f("price")(_vm.totalBonusesAtSelectedDate)) +
            " " +
            _vm._s(
              _vm._f("decl")(_vm.totalBonusesAtSelectedDate, "бонус", [
                "",
                "а",
                "ов"
              ])
            ) +
            "\n    "
        )
      ])
    ]),
    _c(
      "div",
      { ref: "widget-wrap", staticClass: "club-points-calendar__widget-wrap" },
      [
        _c("vue-client-only", [
          _vm.adaptive.isMobile
            ? _c(
                "div",
                { staticClass: "club-points-calendar__widget-month-title" },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.mobileMonthName) + "\n      "
                  )
                ]
              )
            : _c(
                "div",
                {
                  ref: "desktop-month-title-desktop-wrap",
                  staticClass:
                    "club-points-calendar__widget-month-title-desktop-wrap"
                },
                [
                  _c(
                    "div",
                    {
                      ref: "desktop-month-title-desktop",
                      staticClass:
                        "club-points-calendar__widget-month-title-desktop"
                    },
                    _vm._l(_vm.monthsDays, function(days, key) {
                      return _c(
                        "div",
                        {
                          key: key,
                          staticClass:
                            "club-points-calendar__widget-month-title txt-overflow",
                          style: _vm.getWidth(days)
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.keyToMonthName(key)) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
        ]),
        _c(
          "div",
          {
            ref: "days-wrap",
            staticClass: "club-points-calendar__widget-days-wrap",
            on: { scroll: _vm.onScroll }
          },
          [
            _c(
              "div",
              {
                ref: "bonuses",
                staticClass: "club-points-calendar__widget-bonuses"
              },
              _vm._l(_vm.sortedPromos, function(promo, index) {
                return _c("club-calendar-points", {
                  key: index,
                  class: [
                    "club-points-calendar__widget-bonus-item",
                    "promo-points-" + index
                  ],
                  attrs: {
                    type: _vm.getPointsType(promo),
                    title: promo.name,
                    points: promo.bonuses,
                    "starts-earlier": _vm.isPointsStartsEarlier(
                      promo.dateBegin
                    ),
                    "ends-sooner": _vm.isPointsEndsSooner(promo.dateEnd),
                    start: promo.dateBegin,
                    end: promo.dateEnd
                  }
                })
              }),
              1
            ),
            _c(
              "div",
              {
                ref: "widget-month-wrap",
                staticClass: "club-points-calendar__widget-month-wrap"
              },
              _vm._l(_vm.timeLine, function(date, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    ref: "day",
                    refInFor: true,
                    staticClass: "club-points-calendar__widget-day",
                    class: {
                      "club-points-calendar__widget-day_selected": _vm.isSelected(
                        date
                      )
                    },
                    attrs: {
                      "data-year": date.getFullYear(),
                      "data-month": date.getMonth(),
                      "data-day": date.getDate(),
                      "data-key": _vm.makeKey(date)
                    },
                    on: {
                      click: function($event) {
                        return _vm.selectDate(date)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        class: [
                          "club-points-calendar__widget-day-title",
                          {
                            "club-points-calendar__widget-day-title_last-day": _vm.isLastMonthDay(
                              date
                            )
                          }
                        ]
                      },
                      [
                        _c(
                          "div",
                          {
                            class: [
                              "club-points-calendar__widget-day-name",
                              {
                                "club-points-calendar__widget-day-name_weekend": _vm.isWeekend(
                                  date
                                )
                              }
                            ]
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.getDayOfWeek(date)) +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "club-points-calendar__widget-day-number"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.getDayNumber(date)) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }